import React from 'react';
import { Flame, Trophy, Calendar } from 'lucide-react';

const StreakDisplay = ({ streak }) => {
  return (
    <div className="bg-gradient-to-br from-orange-50 to-red-50 rounded-xl shadow-lg p-6 border-2 border-orange-200">
      <div className="flex items-center gap-3 mb-6">
        <Flame className="w-8 h-8 text-orange-600" />
        <h3 className="text-xl font-bold text-gray-900">Practice Streak</h3>
      </div>
      <div className="space-y-6">
        {/* Current Streak */}
        <div className="text-center">
          <div className="text-5xl font-bold text-orange-600 mb-2">
            {streak?.current_streak || 0}
          </div>
          <div className="text-sm text-gray-600">
            {streak?.current_streak === 1 ? 'Day' : 'Days'} in a Row
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-white rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Trophy className="w-5 h-5 text-yellow-600" />
              <span className="text-xs text-gray-600">Longest</span>
            </div>
            <div className="text-2xl font-bold text-gray-900">
              {streak?.longest_streak || 0}
            </div>
            <div className="text-xs text-gray-500">days</div>
          </div>

          <div className="bg-white rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="w-5 h-5 text-blue-600" />
              <span className="text-xs text-gray-600">Total</span>
            </div>
            <div className="text-2xl font-bold text-gray-900">
              {streak?.total_practice_days || 0}
            </div>
            <div className="text-xs text-gray-500">days</div>
          </div>
        </div>

        {/* Last Practice */}
        {streak?.last_practice_date && (
          <div className="bg-white rounded-lg p-4">
            <div className="text-xs text-gray-600 mb-1">Last Practice</div>
            <div className="text-sm font-semibold text-gray-900">
              {new Date(streak.last_practice_date)?.toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
            </div>
          </div>
        )}

        {/* Motivation Message */}
        <div className="bg-white rounded-lg p-4">
          <div className="text-sm text-center">
            {streak?.current_streak === 0 ? (
              <span className="text-gray-600">Start your streak today! 🎯</span>
            ) : streak?.current_streak < 7 ? (
              <span className="text-orange-600">Keep it up! You're building momentum! 🔥</span>
            ) : streak?.current_streak < 30 ? (
              <span className="text-orange-600">Amazing work! You're on fire! 🔥✨</span>
            ) : (
              <span className="text-orange-600">Legendary streak! You're unstoppable! 🔥🏆</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StreakDisplay;